import { Component, OnInit, Input, Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { IAlert } from '../../interfaces';

@Injectable()
export class AlertService {
  private _alert = new Subject<any>();
  private timeout: any;

  alert = this._alert.asObservable();

  constructor() { }

  open(data) {
    this._alert.next({
      isOpen: true,
      data: data,
    });

    this.timeout = setTimeout(() => {
      this._alert.next({
        isOpen: false,
        data: data,
      });
      if (data.callback) {
        data.callback();
      }
      clearTimeout(this.timeout);
    }, data.delay || 3000);
  }

  /************************************************************************
  this._as.fieldError()
  ************************************************************************/

  fieldError(isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: `Une ou plusieurs erreurs sont intervenues. <br/> Veuillez corriger les erreurs et resoumettre le formulaire`,
      color: 'danger',
      delay: 5000
    };
    this.open(data);
  }

  apiError(isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: `Une ou plusieurs erreurs sont intervenues. <br/> Merci de réessayer plus tard`,
      color: 'danger'
    };
    this.open(data);
  }

  uploadError(isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: 'Le poids ou format de votre fichier n\'est pas valide. Merci de choisir une fichier qui réponds aux demandes.',
      color: 'danger',
    };
    this.open(data);
  }

  deleted(isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: 'Supression effectuée avec succès.',
      color: 'success',
    };
    this.open(data);
  }

  success(message, isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: message,
      color: 'success',
    };
    this.open(data);
  }

  warning(message, isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: message,
      color: 'warning',
    };
    this.open(data);
  }

  danger(message, isFull: boolean = false) {
    const data = {
      isFull: isFull,
      message: message,
      color: 'danger',
    };
    this.open(data);
  }
}

@Component({
  selector: 'vq-alert',
  templateUrl: './vq-alert.component.html',
  styles: []
})
export class VQAlertComponent implements OnInit {

  public isOpen = false;
  public timeout: any;

  data: any;

  constructor(
    private _as: AlertService,
  ) { }

  open() {
    this.isOpen = true;
  }

  ngOnInit() {
    this.data = this._as.alert.subscribe((v: IAlert) => {
      this.data = v.data;
      this.timeout = setTimeout(() => {
        this.isOpen = v.isOpen;
        clearTimeout(this.timeout);
      }, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/vqutils/vq-alert/vq-alert.component.ts